import React, { useEffect, useState } from 'react'
import './TrainingPage.css'
import { useNavigate, useParams } from 'react-router';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Col, Row, message } from 'antd';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import axios from 'axios';
import { BaseUrl } from '../../Constants/Constants';
import { useStateValue } from '../../../Reducer/reducer';
import ArticleIcon from '@mui/icons-material/Article';

const TrainingPage = () => {

    const [courseName, setCourseName] = useState("");
    const [expanded, setExpanded] = React.useState(false);
    const [expandedAss, setExpandedAss] = React.useState(false);
    const [courseModule, setCourseModule] = useState([]);
    const [loading, setLoading] = useState(false);
    const [Assesment, setAssesment] = useState('')

    const navigate = useNavigate();
    const [
        { UserID },
        dispatch,
      ] = useStateValue();

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const handleAssessmentAccordion = (panel) => (event, isExpanded) => {
        setExpandedAss(isExpanded ? panel : false);
    };

    const { id, courseId } = useParams();


    useEffect(() => {

        setLoading(true);

        let body = {
            training_id: id,
            userId: UserID
        }

        axios.post(`${BaseUrl}trainings/findTrainingbyUser`, body, { withCredentials: true })

            .then((res) => {

                let response = res.data;

                if (response.statuscode === 200) {
                    console.log(res.data.data, 'courseDetails');
                    setCourseName(response.data.training_title);

                    let courseBody ={
                        courseId : courseId
                    }
        
                    axios.post(`${BaseUrl}course-parts/findOneByCourseId`, courseBody, { withCredentials: true })
                    .then((res) => {
                        let response = res.data
                        console.log(response.data, 'findOneByCourseId');
        
                        if (response.statuscode === 200) {
                            setCourseModule(response.data);
                        }
        
                    })
                    .catch((err) => {
                        console.log(err.message)
                        // setLoading(false);
                    })
                    .finally(() => {
                        setLoading(false);
                    })
                }
                else {
                    setCourseName('');
                    message.error("The training has been marked as inactive because the end date has been reached.");
                    setTimeout(() => {

                        navigate('/')
                    }
                    ,500)

                }
            })
            .catch((err) => {
                console.log(err.message)
            })


           

    }, [])



    useEffect(() => {
        let body = {
            course_id: courseId
        }
        axios
            .post(`${BaseUrl}assesment/list_of_assessments`, body, { withCredentials: true })
            .then((res) => {
                setAssesment(res.data.data)
                console.log(res.data.data, "listOfAssessments")
            })
            .catch((err) => {
                message.error(err.message);
            })
            .finally((res) => {

            })
    }, [])



useEffect(()=>{
console.log("newtest");

},[])


    const assessmentData = [
        {
            icon: <EditNoteOutlinedIcon />,
            testName: `${courseName} assessment`,
            marks: "9/10",
            status: <CheckCircleOutlineOutlinedIcon />
        }
    ]






    return (
        <div className='courseModuleMainDiv'>
            <p className='back'>
                <span onClick={(e) => navigate(`/training`)} style={{ color: '#4096FF', textDecoration: "underline" }}>
                    Trainings
                </span>
                <span>
                    <ArrowForwardIosIcon className='arrow' />
                </span>
                {courseName && <span style={{ color: '#454545', textDecoration: "underline" }}>
                    {courseName}
                </span>}
            </p>
            {
                loading ?

                    <>
                        <div className='Loader' >
                            <img src='/Loader/Ellipsis-2.9s-200px.svg'>
                            </img>
                        </div>
                    </>
                    :
                    <>
                        <div className='courseHeadingDiv'>
                            <h1 className='courseHeading'>{courseName}</h1>
                        </div>

                        <div className='coursesAccordion'>

                            {
                                courseModule.map((item, key) => {
                                    // console.log(item.courses, 'mappedItems');
                                    return (
                                        <Accordion expanded={expanded === `panel${key}`} onChange={handleChange(`panel${key}`)}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1bh-content"
                                                id="panel1bh-header"
                                            >
                                                <p className='accordionHeading'>{item.partNumber} - {item.partTitle}</p>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className='courseSourceDiv'>
                                                    {item.training.map((e, k) => (
                                                        <Row
                                                            onClick={() => {
                                                                // const cleanedString = e.name.replace(/\s+/g, ' ');
                                                                // let modUrl = cleanedString.toLowerCase().split(' ');
                                                                // let url = modUrl.join('-');
                                                                // let structuredUrl = url.split('/').join('-');
                                                                // console.log(e.id, 'structuredUrl')
                                                                navigate(`/training/${id}/${courseId}/pages/${e.id}`);
                                                            }}
                                                            className='courseSourceTypes'>
                                                            <Col span={1} className='sourceIcon'>
                                                                {
                                                                    e.type === 'mp4' ?
                                                                        <PlayCircleOutlinedIcon />
                                                                        :
                                                                        <ArticleIcon />
                                                                }
                                                            </Col>
                                                            <Col span={20} className='courseSourceName'>
                                                                <p>{e.name}</p>
                                                            </Col>
                                                            <Col span={1} className='videoTime'>
                                                                <p>{e.time}</p>
                                                            </Col>
                                                            <Col span={2} className='sourceStatuss'>
                                                                {e.type === 'mp4' ?
                                                                    "Video" : "Document"
                                                                }
                                                            </Col>
                                                        </Row>
                                                    ))
                                                    }

                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    )
                                })

                            }
                        </div>
                        {
                            Assesment.length != 0 ?

                                <>
                                    <div className='assessmentHeadingDiv'>
                                        <h1 className='assessmentHeading'>Assessment</h1>
                                    </div>
                                    <div className='assessmentAccordion'>
                                        <Accordion
                                        // expanded={expandedAss === `panel${key}`} onChange={handleAssessmentAccordion(`panel${key}`)}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1bh-content"
                                                id="panel1bh-header"
                                            >
                                                {/* <p className='accordionHeading'>{courseName}</p> */}
                                                <p className='accordionHeading'>Click here to take the assessment!</p>
                                            </AccordionSummary>
                                            {
                                                Assesment.map((item, key) => {
                                                    // console.log(courseName, 'mappedItems');
                                                    return (
                                                        <AccordionDetails>
                                                            <div className='courseSourceDiv'>
                                                                <Row
                                                                    onClick={() => {
                                                                        // console.log(item, 'structuredUrl')
                                                                        navigate(`/training/${id}/${courseId}/assessment/${item.Assesment_id}`);
                                                                    }}
                                                                    className='courseSourceTypes'>
                                                                    <Col span={1} className='assessmentIcon'>
                                                                        {/* {item.icon} */}
                                                                        <EditNoteOutlinedIcon />
                                                                    </Col>
                                                                    <Col span={18} className='courseSourceName'>
                                                                        <p>{item.Assessment_name}</p>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </AccordionDetails>
                                                    )
                                                })
                                            }
                                        </Accordion>

                                    </div>

                                </>
                                : <></>}
                        {/* <p>
                                    
                                    No Assesments
                                </p> */}
                    </>
            }
        </div>
    )
}

export default TrainingPage